export const installedToast = {
  title: '此追蹤工具已被安裝',
  description: '請增加其他追蹤工具或編輯此追蹤工具',
};
